export const SCROLL_DELAY_MS = 500;

// Save and Cancel leave by pushing the form's view; a Back (POP) to it is the user leaving.
export const OWN_VIEW_REDIRECT_HISTORY_ACTION = 'PUSH';
